import { motion } from "framer-motion";

const carouselImages = [
  {
    url: "https://images.unsplash.com/photo-1582005450386-52b25f82d9bb?w=800&q=80",
    label: "STRATEGY",
  },
  {
    url: "https://images.unsplash.com/photo-1694109010480-2f7aa9ceb339?w=800&q=80",
    label: "SOCIAL MEDIA",
  },
  {
    url: "https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg?auto=compress&cs=tinysrgb&w=800",
    label: "GRAPHIC DESIGN",
  },
  {
    url: "https://images.unsplash.com/photo-1676282827533-d6058df56a69?w=800&q=80",
    label: "MARKETING",
  },
  {
    url: "https://images.pexels.com/photos/2608517/pexels-photo-2608517.jpeg?auto=compress&cs=tinysrgb&w=800",
    label: "VIDEO",
  },
  {
    url: "https://images.unsplash.com/photo-1763705857736-2b4f16a33758?w=800&q=80",
    label: "BRANDING",
  },
  {
    url: "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800",
    label: "REPUTATION",
  },
  {
    url: "https://images.unsplash.com/photo-1562577309-4932fdd64cd1?w=800&q=80",
    label: "COMUNICAZIONE",
  },
  {
    url: "https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=800",
    label: "WEB DESIGN",
  },
  {
    url: "https://images.pexels.com/photos/270637/pexels-photo-270637.jpeg?auto=compress&cs=tinysrgb&w=800",
    label: "SEO",
  },
];

function CarouselRow({ images, direction = "left", speed = 35 }) {
  const doubled = [...images, ...images];
  return (
    <div className="overflow-hidden">
      <div
        className={direction === "left" ? "animate-carousel-left" : "animate-carousel-right"}
        style={{ animationDuration: `${speed}s` }}
      >
        <div className="flex gap-4" style={{ width: "max-content" }}>
          {doubled.map((img, i) => (
            <div
              key={i}
              className="group relative w-[320px] sm:w-[400px] h-[220px] sm:h-[260px] flex-shrink-0 overflow-hidden border border-white/10"
            >
              <img
                src={img.url}
                alt={img.label}
                className="w-full h-full object-cover transition-all duration-700 grayscale-[50%] group-hover:grayscale-0 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/90 via-[#050505]/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4 flex items-end justify-between">
                <span className="font-mono text-[10px] tracking-[0.25em] text-white/90 uppercase">
                  {img.label}
                </span>
                <span className="w-6 h-[1px] bg-[#FF3366]" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function ImageCarousel() {
  const firstRow = carouselImages.slice(0, 5);
  const secondRow = carouselImages.slice(5, 10);

  return (
    <section data-testid="image-carousel-section" className="py-12 sm:py-16 bg-[#050505] overflow-hidden">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="mb-8 max-w-[1440px] mx-auto px-6 sm:px-12">
          <span className="font-mono text-xs tracking-[0.2em] text-[#FF3366] uppercase">
            IL NOSTRO LAVORO
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight mt-2">
            Creativita in <span className="text-[#A3A3A3]">movimento</span>
          </h2>
        </div>

        <div className="space-y-4">
          <CarouselRow images={firstRow} direction="left" speed={40} />
          <CarouselRow images={secondRow} direction="right" speed={45} />
        </div>
      </motion.div>
    </section>
  );
}
